<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '合同'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5vh"
    :close-on-click-modal="false"
  >
    <div class="border-style">基本信息</div>
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同编号" prop="ContractNumber">
            <el-input
              v-model.trim="item.ContractNumber"
              placeholder="请输入合同编号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同类型" prop="ContractTypeID">
            <select2
              v-model="item.ContractTypeID"
              url="basic?type=ContractType"
              placeholder="请选择合同类型"
              noDataText="无类型"
              :emptyValue="0"
              :currentList="currentContractType"
              style="width: 100%"
            ></select2>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同名称" prop="Name">
            <el-input
              v-model.trim="item.Name"
              placeholder="请输入合同名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属客户" prop="ClientID">
            <select2
              labelName="ClientName"
              v-model="item.ClientID"
              url="client"
              :urlParams="urlParams"
              q="ClientName:like"
              :qinwhere="true"
              :queryOne="false"
              :clearable="false"
              :currentList="currentClient"
              placeholder="请选择客户"
              no-data-text="未找到相关客户"
              :emptyValue="0"
              style="width: 100%"
            ></select2>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同签订日期" prop="CheckDay">
            <el-date-picker
              v-model="item.CheckDay"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同开始日期" prop="ContractStartDay">
            <el-date-picker
              v-model="item.ContractStartDay"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="年限" prop="QATime">
            <el-input-number
              v-model="item.QATime"
              :min="1"
              @focus="getInputFocus($event)"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业务组分类" prop="BusinessGroups">
            <el-select
              v-model="item.BusinessGroups"
              :multiple-limit="6"
              multiple
              filterable
              default-first-option
              placeholder="请选择业务组分类"
              style="width: 100%"
            >
              <el-option
                v-for="code in businessGroupList"
                :key="code.Type"
                :label="code.Name"
                :value="code.Type"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同金额" prop="Amount">
            <el-input-number
              v-model="item.Amount"
              :min="0"
              style="width: 100%"
              @focus="getInputFocus($event)"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收金额" prop="ActualAmount">
            <el-input-number
              v-model="item.ActualAmount"
              :min="0"
              style="width: 100%"
              @focus="getInputFocus($event)"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="签订人" prop="SignName">
            <el-input
              v-model.trim="item.SignName"
              placeholder="请输入签订人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"> </el-col>
      </el-row>
      <el-form-item label="备注" prop="Remark">
        <el-input
          v-model.trim="item.Remark"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
      <el-form-item label="文件上传" prop="file">
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :headers="uploadHeader"
          :file-list="fileList"
          :auto-upload="false"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-remove="handleRemove"
          :on-preview="handlePreview"
        >
          <el-button size="mini" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>

    <div class="border-style">工控软件销售信息</div>
    <div class="toolbar">
      <el-button type="primary" size="mini" @click="onCreateSaleInfoClick">
        <i class="fas fa-plus"></i> 新 增
      </el-button>
    </div>
    <el-table :data="saleInfoList" v-loading="loading">
      <el-table-column prop="Value" label="工控软件产品名称" />
      <el-table-column prop="SaleNum" label="销售数量" width="100" />
      <el-table-column prop="Remark" label="备注" width="250" />
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditSaleInfoClick(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteSaleInfo(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="border-style">工控硬件销售信息</div>
    <el-form
      :model="item"
      ref="ipcsaleform"
      label-width="120px"
      label-position="right"
      :rules="rules"
    >
      <el-row :gutter="25">
        <el-form-item
          :label="`${index + 1}.`"
          v-for="(obj, index) in item.IpcSaleInfo"
          :key="index"
          v-if="isShow"
          label-width="40px"
          style="margin-bottom: 0px"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="产品型号"
                label-width="80px"
                :prop="'IpcSaleInfo.' + index + '.IpcProductModelName'"
                :rules="rules.CheckIpcProductModelName"
              >
                <el-select
                  v-model="obj.IpcProductModelName"
                  :clearable="false"
                  placeholder="请选择产品型号"
                  style="width: 100%"
                >
                  <el-option
                    v-for="ele in modelList"
                    :key="ele"
                    :label="ele"
                    :value="ele"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                label="销售台数"
                label-width="80px"
                :prop="'IpcSaleInfo.' + index + '.IpcSaleNum'"
              >
                <el-input-number
                  v-model="obj.IpcSaleNum"
                  :min="0"
                  placeholder="请填写销售台数"
                  @input="change($event)"
                  maxlength="10"
                  style="width: 80%"
                  @focus="getInputFocus($event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                label="实施台数"
                label-width="80px"
                :prop="'IpcSaleInfo.' + index + '.IpcImplementationNum'"
                style="width: 80%"
              >
                <el-input-number
                  v-model="obj.IpcImplementationNum"
                  :min="0"
                  placeholder="请填写实施台数"
                  @input="change($event)"
                  maxlength="10"
                  @focus="getInputFocus($event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                label="单价"
                label-width="50px"
                :prop="'IpcSaleInfo.' + index + '.UnitPrice'"
                style="width: 80%"
              >
                <el-input-number
                  v-model="obj.UnitPrice"
                  :min="0"
                  placeholder="请填写单价"
                  @input="change($event)"
                  maxlength="10"
                  @focus="getInputFocus($event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <i
                v-if="index === item.IpcSaleInfo.length - 1"
                class="fa fa-plus-circle cur-pointer"
                style="
                  font-size: 18px;
                  position: relative;
                  top: 1px;
                  color: #86c042;
                  margin-left: 10px;
                "
                @click="addIpcSaleInfo()"
              ></i>
              <i
                v-if="item.IpcSaleInfo.length > 1"
                class="fa fa-minus-circle mar-lft cur-pointer"
                style="
                  font-size: 18px;
                  position: relative;
                  top: 1px;
                  color: #ee4a47;
                  margin-left: 10px;
                "
                @click="delIpcSaleInfo(index)"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <div>
          <span style="margin-left: 20px; color: #409eff"
            >实际销售/实施信息：</span
          >
          <div
            style="margin-top: 10px; margin-bottom: 10px"
            v-if="item.IpcActSaleInfo && item.IpcActSaleInfo.length > 0"
          >
            <p
              style="margin-top: 10px"
              v-for="(obj, index) in item.IpcActSaleInfo"
              :key="index"
            >
              <span style="margin-left: 60px"
                >产品型号：<el-tag size="small">{{
                  obj.IpcProductModelName
                }}</el-tag></span
              >
              <span style="margin-left: 100px"
                >销售台数:<el-tag size="small">{{
                  obj.IpcSaleNum
                }}</el-tag></span
              >
              <span style="margin-left: 100px"
                >实施台数:<el-tag size="small">{{
                  obj.IpcImplementationNum
                }}</el-tag></span
              >
            </p>
          </div>
          <div style="margin-top: 10px; margin-bottom: 10px" v-else>
            <span style="margin-left: 60px">无相关信息</span>
          </div>
        </div>
      </el-row>
    </el-form>

    <div class="border-style">相关硬件出库列表</div>
    <el-table :data="saleList">
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column
        prop="IpcProductModel.Name"
        label="产品型号名称"
        width="150"
      />
      <el-table-column
        prop="IpcProductModel.Number"
        label="产品型号"
        width="100"
      />
      <el-table-column prop="SN" label="产品SN">
        <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
          <el-tag type="success" v-if="row.Remark">
            {{ row.Remark }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="出库日期" align="center" width="100">
        <template slot-scope="{ row }">
          <div v-if="row.StockoutAt">
            {{ row.StockoutAt.substring(0, 10) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合同">
        <template slot-scope="{ row }">
          <el-tag
            v-for="contractNo in row.ContractNos"
            :key="contractNo"
            style="margin-right: 5px; color: #00b3ca"
            >{{ contractNo }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>

    <el-dialog
      title="销售信息"
      :visible.sync="saleInfoVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onCloseSaleInfoItem"
      width="40%"
    >
      <el-form
        ref="saleInfoItemForm"
        label-width="120px"
        :model="saleInfoItem"
        :rules="saleInfoRules"
      >
        <el-form-item label="工控产品名称" prop="Key">
          <el-select
            v-model="saleInfoItem.Key"
            filterable
            default-first-option
            placeholder="请选择工控产品名称"
            style="width: 100%"
          >
            <el-option
              v-for="soft in softwareList"
              :key="soft.Key"
              :label="soft.Value"
              :value="soft.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售数量" prop="SaleNum">
          <el-input-number
            v-model="saleInfoItem.SaleNum"
            :min="0"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            v-model.trim="saleInfoItem.Remark"
            :autosize="{ minRows: 2 }"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseSaleInfoItem">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onConfirmSaleInfoItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    businessGroupList: Array,
  },
  data() {
    const validateIpcProductModelName = (rule, value, callback) => {
      const arr = rule.fullField.split(".");
      let ipcProductModelName = "";
      let check = false;
      if (arr.length === 3) {
        const index = arr[1];
        if (
          this.item.IpcSaleInfo[index].IpcSaleNum > 0 ||
          this.item.IpcSaleInfo[index].IpcImplementationNum > 0 ||
          this.item.IpcSaleInfo[index].UnitPrice > 0
        ) {
          check = true;
        }
        ipcProductModelName = this.item.IpcSaleInfo[index].IpcProductModelName;
      }
      if (check) {
        if (ipcProductModelName === "") {
          const msg = "产品型号不能为空";
          callback(new Error(msg));
        } else {
          const sameArr = [];
          let haveSame = false;
          this.item.IpcSaleInfo.forEach((item, index) => {
            if (!haveSame) {
              sameArr.forEach((modelName, index) => {
                if (modelName == item.IpcProductModelName) {
                  haveSame = true;
                }
              });
            }
            sameArr.push(item.IpcProductModelName);
          });
          if (haveSame) {
            callback(new Error("产品型号重复"));
            return;
          }
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      uploadUrl: "api/contract/upload",
      fileList: [],
      removeList: [],
      attnum: 0,
      atttimes: 0,
      item: {},
      rules: {
        ContractNumber: [
          { required: true, message: "合同编号不能为空", trigger: "blur" },
        ],
        CheckIpcProductModelName: [
          { validator: validateIpcProductModelName, trigger: "blur" },
        ],
        // Name: [
        //   { required: true, message: "合同名字不能为空", trigger: "blur" },
        // ],
        // CheckDay: [
        //   { required: true, message: "合同签订日期不能为空", trigger: "blur" },
        // ],
        // ContractStartDay: [
        //   { required: true, message: "合同开始日期不能为空", trigger: "blur" },
        // ],
        // ClientID: [
        //   { required: true, message: "客户不能为空", trigger: "blur" },
        // ],
        // ContractTypeID: [
        //   { required: true, message: "合同类型不能为空", trigger: "blur" },
        // ],
        BusinessGroups: [
          { required: true, message: "业务组分类不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
      currentClient: [],
      currentContractType: [],

      softwareList: [], //工控软件产品列表
      saleInfoList: [], //工控软件销售列表
      saleList: [], //工控硬件产品出库列表
      modelList: [], //产品型号
      loading: false,
      saleInfoVisible: false,
      saleInfoItem: {},
      saleInfoRules: {
        Key: [
          { required: true, message: "工控产品名称不能为空", trigger: "blur" },
        ],
        SaleNum: [
          { required: true, message: "销售数量不能为空", trigger: "blur" },
        ],
      },
      maxNum: 0, //记录最大数
      saleInfo: [], //工控软件销售信息JSON
      urlParams: { where: {} },
      isShow: true,
      number: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
  },
  mounted() {
    this.getModelList();
    this.getSoftwareList();
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      this.saleInfoList = [];
      if (this.value.ID) {
        if (this.value.ContractType != null) {
          this.currentContractType = [
            {
              ID: this.value.ContractTypeID,
              Name: this.value.ContractType.Name,
            },
          ];
        }
        if (this.value.Client != null) {
          this.currentClient = [
            {
              ID: this.value.ClientID,
              ClientName: this.value.Client.ClientName,
            },
          ];
        }
        if (this.item.SaleInfo != null && this.item.SaleInfo.length > 0) {
          this.maxNum = this.item.SaleInfo.length;
          for (let index = 0; index < this.item.SaleInfo.length; index++) {
            let element = this.item.SaleInfo[index];
            this.saleInfoList.push({
              ID: index + 1,
              Key: element.Key,
              Value: element.Value,
              SaleNum: element.SaleNum,
              Remark: element.Remark,
            });
          }
        }
        if (this.item.Attachments) {
          this.value.Attachments.forEach((ele) => {
            const file = {};
            // file.id = ele.ID;
            file.name = ele.Name;
            file.url = ele.Url;
            this.fileList.push(file);
          });
        } else {
          this.item.Attachments = [];
        }

        this.getSaleList();
      }

      if (this.item.IpcSaleInfo == null || this.item.IpcSaleInfo.length === 0) {
        this.item.IpcSaleInfo = [];
        this.item.IpcSaleInfo.push({
          IpcProductModelName: "",
          IpcSaleNum: 0,
          IpcImplementationNum: 0,
          UnitPrice: 0,
        });
      }
    },
    addIpcSaleInfo() {
      this.item.IpcSaleInfo.push({
        IpcProductModelName: "",
        IpcSaleNum: 0,
        IpcImplementationNum: 0,
        UnitPrice: 0,
      });
      this.isShow = false;
      this.number += 1;
      this.isShow = true;
    },
    delIpcSaleInfo(index) {
      this.item.IpcSaleInfo.splice(index, 1);

      this.isShow = false;
      this.number -= 1;
      this.isShow = true;
    },
    change() {
      this.$forceUpdate();
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("ipc/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    getSoftwareList() {
      this.$axios
        .get("software/version/function")
        .then((response) => {
          this.softwareList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getSaleList() {
      this.$axios
        .post(`contract/ipcproducts/sales`, {
          contactNo: this.item.ContractNumber,
        })
        .then((response) => {
          this.saleList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onClose() {
      this.saleInfoList = [];
      this.saleList = [];
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.$refs.ipcsaleform.resetFields();
      this.$refs.upload.clearFiles();
      this.fileList = [];
      this.removeList = [];
    },
    getInputFocus(event) {
      event.currentTarget.select();
    }, //聚焦全选
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$refs.ipcsaleform.validate((valid) => {
          if (!valid) {
            return;
          }

          let sum = 0;
          this.item.IpcSaleInfo.forEach((obj, index) => {
            sum += obj.IpcSaleNum * obj.UnitPrice;
          });
          if (sum > this.item.Amount) {
            this.$message({
              type: "warning",
              message: "销售数量单价总额超过合同金额，请重新确认！",
              duration: 1500,
            });
            return;
          }

          this.submitting = true;

          this.attnum = 0; //有没有新上传附件
          this.$refs.upload.uploadFiles.forEach((item) => {
            if (item.status === "ready") {
              this.attnum += 1;
            }
          });
          if (this.attnum > 0) {
            this.atttimes = 0;
            this.$refs.upload.uploadFiles.map(
              (item) => item.status === "ready"
            );
            this.$refs.upload.submit();
          } else {
            this.lastSubmit();
          }
        });
      });
    },

    lastSubmit() {
      if (this.removeList.length !== 0) {
        this.removeList.forEach((ele) => {
          this.item.Attachments.splice(
            this.item.Attachments.findIndex((item) => item.Url === ele),
            1
          );
        });
        this.$axios.delete("contract/dispose", {
          data: { file: this.removeList },
        });
      }

      //工控销软件售信息保存
      this.item.SaleInfo = [];
      for (let index = 0; index < this.saleInfoList.length; index++) {
        let element = this.saleInfoList[index];
        this.item.SaleInfo.push({
          Key: element.Key,
          Value: element.Value,
          SaleNum: element.SaleNum,
          Remark: element.Remark,
        });
      }
      
      if (this.item.IpcSaleInfo.length > 0) {
        this.item.IpcSaleInfo.forEach((obj, index) => {
          if (obj.IpcProductModelName === "") {
            this.item.IpcSaleInfo.splice(index, 1);
          }
        });
      }
      this.$emit("input", this.item);
      const itemData = { ...this.item };
      // 保存的操作
      this.$axios
        .request({
          url: this.item.ID ? `contract/${itemData.ID}` : "contract",
          method: itemData.ID ? "put" : "post",
          data: itemData,
        })
        .then(() => {
          this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
          this.submitting = false;
          this.$emit(itemData.ID ? "form:updated" : "form:created", true);
          this.$emit("form:saved", true);
          this.$emit("update:visible", false);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? "form:updated" : "form:created", false);
          this.$emit("form:saved", false);
        });
    },

    handleSuccess(response) {
      if (this.item.Attachments === null) {
        this.item.Attachments = [];
      }
      this.item.Attachments.push(response);
      this.atttimes += 1; //第几次调用改方法（每个文件都会调用一次，最后一次再触发保存）

      if (this.atttimes === this.attnum) {
        this.lastSubmit();
      }
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
    handleRemove(file) {
      if (file.status === "success") {
        this.removeList.push(file.url);
      }
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },

    //点击新增销售信息按钮
    onCreateSaleInfoClick() {
      this.saleInfoItem = this.getEmptySaleInfoItem();
      this.saleInfoVisible = true;
    },

    //编辑销售信息
    onEditSaleInfoClick(row) {
      this.saleInfoItem = this.getEmptySaleInfoItem();

      this.saleInfoItem.ID = row.ID;
      this.saleInfoItem.Key = row.Key;
      this.saleInfoItem.Value = row.Value;
      this.saleInfoItem.SaleNum = row.SaleNum;
      this.saleInfoItem.Remark = row.Remark;

      this.saleInfoVisible = true;
    },

    //确认新增/保存销售信息
    onConfirmSaleInfoItem() {
      this.$refs.saleInfoItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$emit("input", this.saleInfoItem);
        let itemData = { ...this.saleInfoItem };

        let isHave = false;
        this.saleInfoList.forEach((element) => {
          if (element.Key === itemData.Key && element.ID !== itemData.ID) {
            isHave = true;
          }
        });
        if (isHave) {
          this.$message({
            type: "warning",
            message: "工控软件产品名称不能重复",
            duration: 1500,
          });
          return;
        }

        this.softwareList.forEach((item) => {
          if (item.Key === itemData.Key) {
            itemData.Value = item.Value;
          }
        });

        //新增参数
        if (itemData.ID === 0) {
          this.maxNum += 1;
          itemData.ID = this.maxNum;
          this.saleInfoList.push(itemData);
        } else {
          for (let index = 0; index < this.saleInfoList.length; index++) {
            if (this.saleInfoList[index].ID === itemData.ID) {
              this.$set(this.saleInfoList, index, itemData);
              break;
            }
          }
        }

        this.saleInfoVisible = false;
      });
    },

    //删除销售信息
    onDeleteSaleInfo(row) {
      this.$confirm("确定要删除该信息吗？", "提示")
        .then(() => {
          for (let index = 0; index < this.saleInfoList.length; index++) {
            const element = this.saleInfoList[index];
            if (element.ID === row.ID) {
              this.saleInfoList.splice(index, 1);
              break;
            }
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    getEmptySaleInfoItem() {
      return {
        ID: 0,
        Key: "", //对应获取工控产品列表key
        Value: "", //对应获取工控产品列表key
        SaleNum: 0, //销售数量
        Remark: "", //备注
      };
    },

    onCloseSaleInfoItem() {
      this.saleInfoVisible = false;
      this.$refs.saleInfoItemForm.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
